import BaseService from '../../services/BaseService';

class FormTestInputService extends BaseService{};

export default new FormTestInputService('health_backend', 'form_test_inputs');